import { Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import type { ReactNode } from 'react';
import { Card } from './ui';

/** Gemeinsamer Rahmen für Impressum/Datenschutz — öffentlich erreichbar,
 * ohne Login (siehe `router.tsx`: beide Routen hängen direkt an `rootRoute`,
 * nicht an `appRoute`), deshalb ein eigenes schlankes Layout statt
 * `AppShell`. "Zurück"-Link führt zur vorherigen Seite statt fest zu
 * `/login`, damit es auch funktioniert, wenn jemand von einer bereits
 * eingeloggten Sitzung aus hierher gewechselt ist. */
export function LegalPageLayout({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="min-h-full bg-slate-50 p-4 py-10">
      <div className="mx-auto max-w-3xl space-y-4">
        <button
          type="button"
          onClick={() => window.history.back()}
          className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-700"
        >
          <ArrowLeft size={15} /> Zurück
        </button>
        <h1 className="text-2xl font-bold text-slate-900">{title}</h1>
        <Card>
          <div className="max-w-none space-y-4 text-sm leading-relaxed text-slate-700">{children}</div>
        </Card>
        <div className="flex items-center justify-center gap-2 pt-2 text-xs text-slate-400">
          <Link to="/impressum" className="hover:text-slate-600 hover:underline">
            Impressum
          </Link>
          <span aria-hidden="true">·</span>
          <Link to="/datenschutz" className="hover:text-slate-600 hover:underline">
            Datenschutz
          </Link>
        </div>
      </div>
    </div>
  );
}
